
// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the ApiServices.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
import BaseApi from './BaseApi';
import NewRevenueDivisionVM from '../models/NewRevenueDivisionVM';
import RevenueDivisionEditDetailsVM from '../models/RevenueDivisionEditDetailsVM';
import NewPriceModelVM from '../models/NewPriceModelVM';
import PriceModelEditDetailsVM from '../models/PriceModelEditDetailsVM';
import PriceModelAndRevenueDivisionEditVM from '../models/PriceModelAndRevenueDivisionEditVM';
import CustomerPriceTierVM from '../models/CustomerPriceTierVM';
import AddPriceModelAndTierMultipliersVM from '../models/AddPriceModelAndTierMultipliersVM';
import UpdateItemPriceModelVM from '../models/UpdateItemPriceModelVM';
import PriceModelDataVM from '../models/PriceModelDataVM';
import PriceModelDetailsVM from '../models/PriceModelDetailsVM';
import PriceModelAndTierMultiplierHistoryVM from '../models/PriceModelAndTierMultiplierHistoryVM';
import ItemPriceModelVM from '../models/ItemPriceModelVM';

export class PriceModelsApiService extends BaseApi {

    // get: PriceModelsApiService.GetUserTestingNewPricingModel
    public getUserTestingNewPricingModel_Url = (): string => {
        let url = `api/PriceModels/GetUserTestingNewPricingModel`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public getUserTestingNewPricingModel = (): Promise<boolean> => {
        return this.SendRequest<any, boolean>(null, 'get', this.getUserTestingNewPricingModel_Url(), true, false);
    }

    // post: PriceModelsApiService.UpdateTestNewPricingModel
    public updateTestNewPricingModel_Url = (value: boolean): string => {
        let url = `api/PriceModels/UpdateTestNewPricingModel`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (value != null) {
            url += `${prefix}value=${value}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public updateTestNewPricingModel = (value: boolean): Promise<void> => {
        return this.SendRequest<any, void>(null, 'post', this.updateTestNewPricingModel_Url(value), true, false);
    }

    // get: PriceModelsApiService.GetPriceModelData
    public getPriceModelData_Url = (): string => {
        let url = `api/PriceModels/GetPriceModelData`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public getPriceModelData = (): Promise<PriceModelDataVM> => {
        return this.SendRequest<any, PriceModelDataVM>(null, 'get', this.getPriceModelData_Url(), true, false);
    }

    // post: PriceModelsApiService.AddNewRevenueDivision
    public addNewRevenueDivision_Url = (model: NewRevenueDivisionVM): string => {
        let url = `api/PriceModels/AddNewRevenueDivision`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public addNewRevenueDivision = (model: NewRevenueDivisionVM): Promise<number> => {
        return this.SendRequest<any, number>(model, 'post', this.addNewRevenueDivision_Url(model), true, false);
    }

    // post: PriceModelsApiService.EditRevenueDivisionDetails
    public editRevenueDivisionDetails_Url = (model: RevenueDivisionEditDetailsVM): string => {
        let url = `api/PriceModels/EditRevenueDivisionDetails`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public editRevenueDivisionDetails = (model: RevenueDivisionEditDetailsVM): Promise<void> => {
        return this.SendRequest<any, void>(model, 'post', this.editRevenueDivisionDetails_Url(model), true, false);
    }

    // post: PriceModelsApiService.AddNewPriceModel
    public addNewPriceModel_Url = (model: NewPriceModelVM): string => {
        let url = `api/PriceModels/AddNewPriceModel`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public addNewPriceModel = (model: NewPriceModelVM): Promise<number> => {
        return this.SendRequest<any, number>(model, 'post', this.addNewPriceModel_Url(model), true, false);
    }

    // get: PriceModelsApiService.GetPriceModelDetails
    public getPriceModelDetails_Url = (id: number): string => {
        let url = `api/PriceModels/GetPriceModelDetails`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (id != null) {
            url += `${prefix}id=${id}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public getPriceModelDetails = (id: number): Promise<PriceModelDetailsVM> => {
        return this.SendRequest<any, PriceModelDetailsVM>(null, 'get', this.getPriceModelDetails_Url(id), true, false);
    }

    // post: PriceModelsApiService.EditPriceModelDetails
    public editPriceModelDetails_Url = (model: PriceModelEditDetailsVM): string => {
        let url = `api/PriceModels/EditPriceModelDetails`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public editPriceModelDetails = (model: PriceModelEditDetailsVM): Promise<void> => {
        return this.SendRequest<any, void>(model, 'post', this.editPriceModelDetails_Url(model), true, false);
    }

    // get: PriceModelsApiService.GetCustomerPriceTiers
    public getCustomerPriceTiers_Url = (): string => {
        let url = `api/PriceModels/GetCustomerPriceTiers`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public getCustomerPriceTiers = (): Promise<CustomerPriceTierVM[]> => {
        return this.SendRequest<any, CustomerPriceTierVM[]>(null, 'get', this.getCustomerPriceTiers_Url(), true, false);
    }

    // post: PriceModelsApiService.EditPriceModelAndRevenueDivision
    public editPriceModelAndRevenueDivision_Url = (model: PriceModelAndRevenueDivisionEditVM): string => {
        let url = `api/PriceModels/EditPriceModelAndRevenueDivision`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public editPriceModelAndRevenueDivision = (model: PriceModelAndRevenueDivisionEditVM): Promise<void> => {
        return this.SendRequest<any, void>(model, 'post', this.editPriceModelAndRevenueDivision_Url(model), true, false);
    }

    // post: PriceModelsApiService.SaveCustomerPriceTier
    public saveCustomerPriceTier_Url = (model: CustomerPriceTierVM[]): string => {
        let url = `api/PriceModels/SaveCustomerPriceTier`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public saveCustomerPriceTier = (model: CustomerPriceTierVM[]): Promise<CustomerPriceTierVM[]> => {
        return this.SendRequest<any, CustomerPriceTierVM[]>(model, 'post', this.saveCustomerPriceTier_Url(model), true, false);
    }

    // post: PriceModelsApiService.AddMultipliers
    public addMultipliers_Url = (model: AddPriceModelAndTierMultipliersVM): string => {
        let url = `api/PriceModels/AddMultipliers`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public addMultipliers = (model: AddPriceModelAndTierMultipliersVM): Promise<void> => {
        return this.SendRequest<any, void>(model, 'post', this.addMultipliers_Url(model), true, false);
    }

    // get: PriceModelsApiService.GetMultiplierHistory
    public getMultiplierHistory_Url = (priceModelID: number): string => {
        let url = `api/PriceModels/GetMultiplierHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (priceModelID != null) {
            url += `${prefix}priceModelID=${priceModelID}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public getMultiplierHistory = (priceModelID: number): Promise<PriceModelAndTierMultiplierHistoryVM[]> => {
        return this.SendRequest<any, PriceModelAndTierMultiplierHistoryVM[]>(null, 'get', this.getMultiplierHistory_Url(priceModelID), true, false);
    }

    // get: PriceModelsApiService.GetItemPriceModelHistory
    public getItemPriceModelHistory_Url = (itemNumber: string, isMerch: boolean): string => {
        let url = `api/PriceModels/GetItemPriceModelHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (itemNumber != null) {
            url += `${prefix}itemNumber=${encodeURIComponent(itemNumber)}`;
            prefix = '&';
        }
        if (isMerch != null) {
            url += `${prefix}isMerch=${isMerch}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public getItemPriceModelHistory = (itemNumber: string, isMerch: boolean): Promise<ItemPriceModelVM[]> => {
        return this.SendRequest<any, ItemPriceModelVM[]>(null, 'get', this.getItemPriceModelHistory_Url(itemNumber, isMerch), true, false);
    }

    // post: PriceModelsApiService.UpdateItemPriceModel
    public updateItemPriceModel_Url = (model: UpdateItemPriceModelVM): string => {
        let url = `api/PriceModels/UpdateItemPriceModel`;

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public updateItemPriceModel = (model: UpdateItemPriceModelVM): Promise<void> => {
        return this.SendRequest<any, void>(model, 'post', this.updateItemPriceModel_Url(model), true, false);
    }

    // delete: PriceModelsApiService.DeleteItemPriceModel
    public deleteItemPriceModel_Url = (itemPriceModelId: number, isMerch: boolean): string => {
        let url = `api/PriceModels/DeleteItemPriceModel`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (itemPriceModelId != null) {
            url += `${prefix}itemPriceModelId=${itemPriceModelId}`;
            prefix = '&';
        }
        if (isMerch != null) {
            url += `${prefix}isMerch=${isMerch}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return url;
    }

    public deleteItemPriceModel = (itemPriceModelId: number, isMerch: boolean): Promise<void> => {
        return this.SendRequest<any, void>(null, 'delete', this.deleteItemPriceModel_Url(itemPriceModelId, isMerch), true, false);
    }
}
var service = new PriceModelsApiService();
export default service;
